export default "__VITE_ASSET__$AaIQYIA__"